import { useCallback, useState } from "react";
function useDisplayType(initialDisplayType = "map") {
    const [displayType, setDisplayType] = useState(initialDisplayType);
    const change = useCallback((type) => {
        setDisplayType(type);
    }, []);
    const toggle = useCallback(() => {
        setDisplayType((current) => {
            return current === "map" ? "list" : "map";
        });
    }, []);
    const isMap = displayType === "map";
    const isList = displayType === "list";
    return { isMap, isList, toggle, change };
}
export { useDisplayType };
//# sourceMappingURL=useDisplayType.js.map